import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';


@Component({
  selector: 'app-order-history-box',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})



export class OrderHistoryIndex implements OnInit {
tabSelectedIndex: number = 0
constructor(private router:Router,private route:ActivatedRoute) {
  this.router.events.pipe(
    filter(event => event instanceof NavigationEnd)
  ).subscribe(() => {
    window.scrollTo(0, 0);
  });
 }

 //init
  ngOnInit(): void {
    this.route.queryParams.subscribe(params=>{
      const tabSelectNumber = params['tabSelectNumber'];
      if(tabSelectNumber){
        this.tabSelectedIndex = tabSelectNumber;
      }
    })
  }

  hasPermission(title: string): boolean {
    const menuData = JSON.parse(localStorage.getItem('menu') || '[]');
    // only check childNote
    return menuData.some((menu: any) => 
      menu.childNode && this.checkChildNodes(menu.childNode, title)
    );
  }
  
  checkChildNodes(childNodes: any[], title: string): boolean {
    return childNodes.some((child: any) => 
      child.url === title || (child.childNode && this.checkChildNodes(child.childNode, title))
    );
  }
   
}
